/**
 * Households API Service
 *
 * With Better Auth, session cookies are sent automatically via credentials: 'include'.
 */

import { apiFetch } from "./client";
import type {
  HouseholdResponse,
  HouseholdInvite,
  InvitePreview,
} from "./types";

/** The caller's household with members and active invite, or null. */
export async function getMyHousehold(): Promise<HouseholdResponse> {
  return apiFetch<HouseholdResponse>("/households/me");
}

/** Create/rotate the household's invite (lazily creates the household). */
export async function createHouseholdInvite(): Promise<HouseholdInvite> {
  return apiFetch<HouseholdInvite>("/households/invites", { method: "POST" });
}

/** Preview an invite for the join page ("{inviter} invited you"). */
export async function getInvitePreview(token: string): Promise<InvitePreview> {
  return apiFetch<InvitePreview>(
    `/households/invites/${encodeURIComponent(token)}`,
  );
}

/** Join the household behind an invite token. */
export async function joinHousehold(token: string): Promise<HouseholdResponse> {
  return apiFetch<HouseholdResponse>("/households/join", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
}

/** Leave the current household. */
export async function leaveHousehold(): Promise<void> {
  return apiFetch<void>("/households/me/membership", { method: "DELETE" });
}
